import { apiPost } from './apiClient';
import { addReportToServer, reportApiRole } from '../functions/sendReport';

/** Served from public/assets/ so Amplify serves mp4/otf without /static/media rewrites */
export const ASSET = {
  img: (name) => `/assets/img/${name}`,
  video: (name) => `/assets/video/${name}`,
  font: (name) => `/assets/fonts/${name}`,
};

export function pad2(n) {
  return String(n).padStart(2, '0');
}

export function formatHMS(totalSec) {
  const s = Math.max(0, Math.floor(Number(totalSec) || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return `${pad2(h)}:${pad2(m)}:${pad2(sec)}`;
}

export function parseHMS(hms) {
  if (!hms) return 0;
  const parts = String(hms).split(':').map((x) => parseInt(x, 10) || 0);
  if (parts.length < 3) return 0;
  return parts[0] * 3600 + parts[1] * 60 + parts[2];
}

export function formatDisplayMMSS(totalSec) {
  const s = Math.max(0, Math.floor(Number(totalSec) || 0));
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${pad2(m)}:${pad2(sec)}`;
}

export function userDisplayName(user) {
  if (!user) return 'User';
  const n = `${user.firstName || ''} ${user.lastName || ''}`.trim();
  if (n && n !== 'null null') return n;
  if (user.name && user.name !== 'null') return user.name;
  return user.email?.split('@')[0] || user.userId || 'User';
}

export async function fetchProgress(user) {
  return apiPost('/game/progress', { userId: user.userId });
}

export async function startGame(user) {
  return apiPost('/game/start', {
    userId: user.userId,
    name: userDisplayName(user),
    email: user.email || '',
    user_type: user.role || user.source || '',
    roles: user.role || user.source || '',
  });
}

export async function stagecheck(user) {
  const res = await apiPost('/game/stagecheck', { userId: user.userId });
  return Number(res.points) || 0;
}

export async function submitStage(user, { points, points1, round, skipbtn = 'false', timee, reportId }) {
  return apiPost('/game/submit', {
    userId: user.userId,
    name: userDisplayName(user),
    points,
    points1,
    round,
    skipbtn,
    timee,
    reportId: reportId || user.reportId || null,
  });
}

export async function saveReportId(user, reportId) {
  if (!reportId) return null;
  return apiPost('/game/saveReportId', { userId: user.userId, reportId });
}

export async function fetchLeaderboard(user) {
  return apiPost('/leaderboard', {});
}

/**
 * PHP-like reporting: create on first start; update each stage;
 * guests only update on round 7.
 */
export async function reportOnStart(user, preferReportId) {
  if (!user || user.sessionId === 'demobypass') return null;
  await addReportToServer(user, {
    points: 0,
    reportTime: '00:00:00',
    answers: [],
    preferReportId: preferReportId || user.reportId || null,
  });
  // Wait for serialized report chain, then read persisted id
  await new Promise((r) => setTimeout(r, 50));
  try {
    const raw = localStorage.getItem('userData');
    if (raw) {
      const u = JSON.parse(raw);
      if (u.reportId) {
        await saveReportId(user, u.reportId);
        return u.reportId;
      }
    }
  } catch {
    /* ignore */
  }
  return preferReportId || null;
}

export async function reportOnSubmit(user, { points, timee, round, reportId }) {
  if (!user || user.sessionId === 'demobypass') return;
  const role = reportApiRole(user);
  if (role === 'GUEST_USER' && Number(round) !== 7) return;
  await addReportToServer(user, {
    points,
    reportTime: timee,
    answers: [`stage${round}`],
    preferReportId: reportId || user.reportId || null,
  });
}
